<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Human Resource Information System</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; Coded<i class="fa fa-heart heart"></i> by Jayvee Ayao at
        <a href="https://github.com/cristijora" target="_blank">Blueprint Business Solutions Corp</a>.
        <!-- Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>. -->
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue